import { useMutation } from '@tanstack/react-query';
import { SSF } from '~/apis/api';

export function useRegisterMutation() {
  return useMutation({
    mutationFn: SSF.api.authRegisterCreate,
  });
}

export function useVerifyEmailMutation() {
  return useMutation({
    mutationFn: SSF.api.authEmailVerifyCreate,
  });
}
